export interface MergeableVersion {
    id: string;
    buzzVersion?: {
        id: string;
    };
    mergedTargetId?: string;
}

export const validateVersionsMergeability = (versionsToMerge: MergeableVersion[]): boolean => {
    if (versionsToMerge.length > 2) return false;

    const target = versionsToMerge[0];
    const orphan = versionsToMerge[1];

    return canVersionsMerge(target, orphan);
};

const canVersionsMerge = (target?: MergeableVersion, orphan?: MergeableVersion): boolean => {
    if (anyVersionAlreadyMerged(target, orphan)) return false;

    if (!target || !orphan) return true;

    if (target.id === orphan.id) return false;

    if (!onlyOneVersionHasBuzzVersion(target, orphan)) return false;

    return true;
};

const anyVersionAlreadyMerged = (target?: MergeableVersion, orphan?: MergeableVersion) => {
    return !!target?.mergedTargetId || !!orphan?.mergedTargetId;
};

const onlyOneVersionHasBuzzVersion = (target: MergeableVersion, orphan: MergeableVersion) => {
    return !!target.buzzVersion !== !!orphan.buzzVersion;
};
